import { TemplateResult } from "lit-html";
import { InputComponent } from "@components/common";

export const SuggestedLocationTemplate = (suggestedLocation: string): TemplateResult =>
  InputComponent({
    type: 'text',
    cssClasses: 'jr-typeahead-input jr-typeahead-input--material',
    value: suggestedLocation,
    options: {
      tabIndex: '-1',
      autoComplete: 'off',
      readOnly: true
    }
  })
